import { render } from "./SelectPartner.vue?vue&type=template&id=4ce950d7&scoped=true"
import script from "./SelectPartner.vue?vue&type=script&lang=js"
export * from "./SelectPartner.vue?vue&type=script&lang=js"

import "./SelectPartner.vue?vue&type=style&index=0&id=4ce950d7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce950d7"]])

export default __exports__